import { jsx as _jsx } from "react/jsx-runtime";
import { UniversalDialog } from '../../../dialogs/universal';
import { ViewConfig } from 'z3k-settings/components/view-config';
export function Z3kConfigViewerDialog(props) {
    const { open, close } = props;
    return (_jsx(UniversalDialog, { title: "Z3kConfig Reader", open: open, onClose: close, children: _jsx(ViewConfig, {}) }));
}
